export default __webpack_public_path__ + "static/media/menu-terms-and-conditions-icon.ffdf2f8f.svg";